// extracted by mini-css-extract-plugin
export var root = "c72dead6eeb342fa38b3fce0deda0f99-css";